export default "__VITE_ASSET__28950da2__"